import React, { useState, useEffect } from "react";
import "./Transferotp.css";
import logo from "../assets/logo.png";
import API from "../api/api";
import { useNavigate, useLocation } from "react-router-dom";

// Coin icons for receipt
import btc from "../assets/btc.png";
import eth from "../assets/eth.png";
import bnb from "../assets/bnb.png";
import sol from "../assets/sol.png";
import xrp from "../assets/xrp.png";
import doge from "../assets/doge.png";
import ltc from "../assets/ltc.png";
import trx from "../assets/trx.png";
import usdt from "../assets/usdt.png";
import usdttether from "../assets/usdttether.png";

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need assistance with transfer verification on SafepalPay.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float-unique ${pulseEffect ? 'pulse-unique' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp for OTP assistance"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 32 32"
        fill="white"
      >
        <path d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.645.867 5.084 2.329 7.058L5 29l7.142-1.875A11.96 11.96 0 0016 27c6.627 0 12-5.373 12-11.999C28 8.373 22.627 3 16.001 3zm0 21.999c-1.924 0-3.715-.57-5.219-1.548l-.372-.23-4.242 1.114 1.133-4.135-.242-.384A9.957 9.957 0 016 15.001C6 9.486 10.486 5 16.001 5 21.515 5 26 9.486 26 15.001c0 5.514-4.485 9.998-9.999 9.998zm5.548-7.557c-.303-.151-1.793-.886-2.071-.987-.279-.101-.483-.151-.687.151-.202.302-.787.987-.965 1.19-.177.202-.354.227-.656.075-.303-.151-1.279-.471-2.435-1.5-.9-.802-1.508-1.792-1.686-2.094-.177-.303-.019-.467.133-.619.136-.135.303-.354.455-.531.152-.177.202-.303.303-.505.101-.202.051-.379-.025-.531-.076-.151-.687-1.656-.941-2.269-.247-.592-.498-.512-.687-.521-.177-.008-.379-.01-.582-.01-.202 0-.531.075-.808.379-.278.303-1.06 1.035-1.06 2.524 0 1.488 1.085 2.926 1.237 3.128.151.202 2.14 3.27 5.183 4.588.724.312 1.288.498 1.728.637.726.231 1.387.198 1.911.12.583-.087 1.793-.733 2.047-1.44.253-.707.253-1.313.177-1.44-.076-.126-.278-.198-.581-.354z" />
      </svg>
    </a>
  );
};

const coinIcons = {
  btc: btc,
  eth: eth,
  bnb: bnb,
  sol: sol,
  xrp: xrp,
  doge: doge,
  ltc: ltc,
  trx: trx,
  usdtTron: usdt,
  usdtBnb: usdttether,
};

const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);

const Transferotp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    success: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [transferData, setTransferData] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [showReceipt, setShowReceipt] = useState(false);
  const [completedTransfer, setCompletedTransfer] = useState(null);
  const [resendTimer, setResendTimer] = useState(0);
  const [receiptDetails, setReceiptDetails] = useState({
    amount: 0,
    usdAmount: 0,
    asset: "",
    assetName: "",
    toAddress: "",
    txId: "",
    date: new Date().toLocaleDateString(),
    time: new Date().toLocaleTimeString(),
  });

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";
    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };
  }, []);

  // Pass user email to Crisp when available
  useEffect(() => {
    const storedUserEmail = localStorage.getItem("userEmail");
    const userName = localStorage.getItem("userName");
    
    if (storedUserEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", storedUserEmail]);
      if (userName) {
        window.$crisp.push(["set", "user:nickname", userName]);
      }
    }
  }, []);

  // Timer for resend button
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // Get data from location state
  useEffect(() => {
    if (location.state) {
      const { transferData, userEmail, coinAmount, usdAmount, assetName, price } = location.state;
      
      if (transferData) {
        setTransferData(transferData);
        setReceiptDetails({
          amount: coinAmount || transferData.amount,
          usdAmount: usdAmount || (coinAmount * price),
          asset: transferData.asset,
          assetName: assetName || transferData.asset.toUpperCase(),
          toAddress: transferData.toAddress,
          txId: transferData.transferId,
          date: new Date().toLocaleDateString(),
          time: new Date().toLocaleTimeString(),
        });
      }
      
      if (userEmail) {
        setUserEmail(userEmail);
        localStorage.setItem("userEmail", userEmail);
      } else {
        const savedEmail = localStorage.getItem("userEmail");
        if (savedEmail) {
          setUserEmail(savedEmail);
        }
      }
    } else {
      navigate("/dashboard");
    }
  }, [location, navigate]);

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`to-otp-${index + 1}`).focus();
    }

    if (!value && index > 0) {
      document.getElementById(`to-otp-${index - 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`to-otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    
    if (/^\d{6}$/.test(pastedData)) {
      const otpArray = pastedData.split("").slice(0, 6);
      setOtp(otpArray);
      setTimeout(() => {
        document.getElementById(`to-otp-5`).focus();
      }, 0);
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      setPopup({ show: true, message: "Please enter complete 6-digit code", success: false });
      return;
    }

    if (!transferData) {
      setPopup({ show: true, message: "Transfer data not found", success: false });
      return;
    }

    setIsLoading(true);
    try {
      const res = await API.post(
        "/transfer/verify-otp",
        {
          otp: otpCode,
          transferId: transferData.transferId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setCompletedTransfer(res.data.data);
      
      if (res.data.data) {
        setReceiptDetails(prev => ({
          ...prev,
          txId: res.data.data._id || prev.txId,
          status: res.data.data.status || "completed",
        }));
      }
      
      setShowReceipt(true);

    } catch (error) {
      setPopup({
        show: true,
        message: error.response?.data?.error || "Invalid or expired OTP",
        success: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (!transferData) {
      setPopup({ show: true, message: "Transfer data not found", success: false });
      return;
    }

    if (resendTimer > 0) {
      setPopup({
        show: true,
        message: `Please wait ${resendTimer} seconds before requesting again`,
        success: false,
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await API.post(
        "/transfer/resend-otp",
        {
          transferId: transferData.transferId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setPopup({
        show: true,
        message: response.data.message || "New OTP sent to your email",
        success: true,
      });

      setResendTimer(60);
      setOtp(["", "", "", "", "", ""]);
      
      setTimeout(() => {
        document.getElementById(`to-otp-0`)?.focus();
      }, 100);

    } catch (error) {
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          "Failed to resend OTP. Please try again.";
      
      setPopup({
        show: true,
        message: errorMessage,
        success: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewTransaction = () => {
    if (completedTransfer && completedTransfer._id) {
      navigate(`/transaction/${completedTransfer._id}`);
    } else if (transferData && transferData.transferId) {
      navigate(`/transaction/${transferData.transferId}`);
    } else {
      navigate("/dashboard");
    }
  };

  const handleClosePopup = () => {
    setPopup({ ...popup, show: false });
  };

  // If showReceipt is true, directly show the receipt
  if (showReceipt) {
    const assetIcon = coinIcons[receiptDetails.asset] || null;
    const formattedAmount = receiptDetails.amount.toFixed(8);
    const formattedUsdAmount = formatCurrency(receiptDetails.usdAmount);

    return (
      <>
        <div className="to-btc-send-page-unique">
          <div className="to-btc-send-logo-unique">
            <img src={logo} alt="SafepalPay" />
          </div>

          <div className="to-stx-popup-overlay-unique">
            <div className="to-stx-popup-unique to-stx-success-unique">
              <div className="to-stx-icon-box-unique to-stx-success-unique">
                <svg viewBox="0 0 100 100" className="to-stx-icon-unique">
                  <circle cx="50" cy="50" r="45" className="to-stx-circle-unique" />
                  <path
                    className="to-stx-path-unique"
                    d="M30 52 L45 65 L70 38"
                  />
                </svg>
              </div>

              <h2 className="to-stx-popup-title-unique">
                Transaction Successful!
              </h2>

              <p className="to-stx-popup-text-unique">
                Your amount will be credited after successful network confirmation
              </p>

              <button
                className="to-stx-popup-btn-unique"
                onClick={handleViewTransaction}
              >
                View Transaction
              </button>
            </div>
          </div>
        </div>
        
        <WhatsAppFloat 
          phoneNumber="15485825756"
          message="Hello! I need assistance with transfer verification on SafepalPay."
          position="right"
          bottom="30px"
          right="30px"
          pulseEffect={true}
        />
      </>
    );
  }

  // Original OTP input page
  return (
    <>
      <div className="to-transfer-successful-container-unique">
        <div className="to-transfer-successful-card-unique">
          <span className="to-transferotp-back-unique" onClick={() => navigate(-1)}>←</span> 
          
          <div className="to-transfer-successful-logo-unique">
            <img src={logo} alt="SafepalPay" />
          </div>

          <h2 className="to-transfer-successful-title-unique">Transfer Verification</h2>
          <p className="to-transfer-successful-text-unique">
            We have sent the verification code <br />
            to your email address. Please check your Spam or Junk folder if it doesn't appear shortly.
          </p>

          {/* Email display */}
          {userEmail && (
            <p className="to-transfer-successful-email-unique">
              <strong>Email:</strong> {userEmail}
            </p>
          )}

          {/* OTP Inputs */}
          <div 
            className="to-transfer-successful-otp-boxes-unique" 
            onPaste={handlePaste}
          >
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`to-otp-${index}`}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                autoFocus={index === 0}
                disabled={isLoading}
              />
            ))}
          </div>

          <button 
            className="to-transfer-successful-submit-btn-unique" 
            onClick={handleSubmit}
            disabled={isLoading || otp.join("").length !== 6}
          >
            {isLoading ? "Verifying..." : "Verify & Complete Transfer"}
          </button>

          <p className="to-transfer-successful-resend-text-unique">
            Didn't receive code?{" "}
            <button 
              className="to-transfer-successful-resend-btn-unique" 
              onClick={handleResendCode}
              disabled={isLoading || resendTimer > 0}
            >
              {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend Code"}
            </button>
          </p>
        </div>

        {/* ANIMATED POPUP */}
        {popup.show && (
          <div className="to-transfer-successful-popup-overlay-unique">
            <div className="to-transfer-successful-popup-card-unique">
              <div className={`to-transfer-successful-icon-box-unique ${popup.success ? "to-success-unique" : "to-error-unique"}`}>
                <svg viewBox="0 0 100 100" className="to-transfer-successful-icon-unique">
                  <circle cx="50" cy="50" r="45" className="to-transfer-successful-circle-unique" />
                  <path
                    className="to-transfer-successful-path-unique"
                    d={
                      popup.success
                        ? "M30 52 L45 65 L70 38"
                        : "M35 35 L65 65 M65 35 L35 65"
                    }
                  />
                </svg>
              </div>

              <p className="to-transfer-successful-popup-text-unique">{popup.message}</p>

              <button
                className="to-transfer-successful-ok-btn-unique"
                onClick={handleClosePopup}
                disabled={isLoading}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
      
      {/* WhatsApp Float Button */}
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need assistance with transfer verification on SafepalPay."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
        size="54px"
        iconSize="28px"
      />
    </>
  );
};

export default Transferotp;